import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/global.less";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// import "antd/dist/antd.css";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
